module.exports = __webpack_public_path__ + "static/project-1-65dbae0e5e6b876100841f79de0e3aad.jpg";